import { ModeOption, ProviderModeId } from "../../../utils/integrationConfigData";

interface ProviderModeToggleProps {
  modes: ModeOption[];
  activeMode: ProviderModeId;
  onChange: (mode: ProviderModeId) => void;
}

const ProviderModeToggle = ({
  modes,
  activeMode,
  onChange,
}: ProviderModeToggleProps) => {
  return (
    <div className="ic-mode-toggle" role="group" aria-label="Provider mode">
      {modes.map((mode) => (
        <button
          key={mode.id}
          type="button"
          className={`ic-mode-btn ${activeMode === mode.id ? "active" : ""}`}
          onClick={() => onChange(mode.id)}
        >
          {mode.label}
        </button>
      ))}
    </div>
  );
};

export default ProviderModeToggle;
